import React, { useState } from 'react';
import moment from 'moment';
import { PublicEndpoint } from '../../../utils/axios';

export const TermsOfUseComponent = () => {
    const [status, setStatus] = useState('loading');
    const [termsPageData, setTermsPageData] = useState(null);

    React.useEffect(() => {
        setStatus('loading');
        setTermsPageData(''); // Reset termsPageData before fetching new data
        callTermsAPI()
        .then((res) => {
            if (res) {
                setTermsPageData(res);
                setStatus('loaded');
            }
            else {
                setStatus('error');
                console.error('Log: Error occurred while fetching terms API data: Invalid response format');
            }
        })
        .catch((err) => {
            setStatus('error');
            console.error('Log: Error occurred while fetching terms API data:', err);
        });
    }, []);
    
    async function callTermsAPI() {
        return PublicEndpoint.get('termsOfUse');
    }

    const getTextElement = (lineItem, index) => {
        if (lineItem.type === 'paragraph') {
            const isLastLine = lineItem?.children?.some( (child) => child?.type === 'text' && child?.text?.includes('By using the nGO/nGO Portal,')) === true;

            const classNames = [
                isLastLine ? 'terms-last-line-css' : '',
            ].filter(Boolean).join(' ');
            return (
            <p key={index} className={classNames}>
                {lineItem?.children?.map((child, childIndex) => {
                    if (child?.type === 'text' && child?.text?.includes('@forthcode.com')) {
                        const email = child.text.trim();
                        return <span key={childIndex}><a href={`mailto:${email}`} className="terms-email-css">{child.text}</a></span>;
                    }
                    else if (child.type === 'text') {
                        return <span key={childIndex}>
                            {child.bold ? <strong style={{ color: 'var(--text-primary)' }}>{child.text}</strong> : child.text}
                        </span>;
                    } else {
                        return <span key={childIndex}>{child.text || ''}</span>;
                    }
                })}
            </p>);
        } else if (lineItem.type === 'heading') {
            const HeadingTag = `h${lineItem.level}`;

            return lineItem.children.map((child, childIndex) => {
                return <HeadingTag key={childIndex}>
                    {child.bold ? <strong style={{ color: 'var(--text-primary)' }}>{child.text}</strong> : child.text}
                </HeadingTag>;
            });
            
        } else {
            return null;
        }                    
    };

    return (
    <>
        <div className="cfg-page-header">
            <h1>End User License Agreement (EULA)</h1>
            <p>Terms governing your access to and use of the nGO Portal.</p>
        </div>
        
        <div className="cfg-terms-doc">
            {status === 'loading' ? 
                <div className="terms-loading">Loading...</div> 
                :
                <>
                    {status === 'error' ?
                        <div className="terms-error">Error loading content. Please try again later.</div> : 
                        <>
                            {
                                termsPageData && termsPageData?.content && termsPageData?.content.length > 0 ? 
                                ( 
                                    <>
                                        <div className="terms-meta">Last Updated: {termsPageData?.updatedAt ? moment(termsPageData.updatedAt).format('LL') : '-'} &nbsp;·&nbsp; Governing Law: India &nbsp;·&nbsp; Forthcode Technologies India Pvt Ltd</div>

                                        <div className="terms-content">
                                            {termsPageData.content.map((text, index) => (
                                                <div key={index}>
                                                    {getTextElement(text, index)}
                                                </div>
                                            ))}
                                        </div>
                                        
                                    </>
                                ) : 
                                <div className="terms-error">No content available.</div>
                            }
                        </>
                    }
                </>
            }
        </div>
    </>
    );
};